import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LuigiDataConfigService } from '@jukebox/common';

@Injectable({
  providedIn: 'root',
})
export class DxpLuigiDataConfigService extends LuigiDataConfigService {
  constructor(http: HttpClient) {
    super(http);
  }
}
